export function localized(text, active, defaultLocale) {
    if (!text) {
        return "";
    }
    const fromActive = text[active];
    if (fromActive) {
        return fromActive;
    }
    const fromDefault = text[defaultLocale];
    if (fromDefault) {
        return fromDefault;
    }
    for (const value of Object.values(text)) {
        if (value) {
            return value;
        }
    }
    return "";
}
